import { requestData } from "@/api/request";
import { Id } from "@/types/common";

export interface AdminStatItemVO {
  name: string;
  count: number;
}

export interface AdminSubmissionTrendVO {
  date: string;
  count: number;
}

export interface AdminRecentActivityVO {
  submissionId: Id;
  userId?: Id;
  userName?: string;
  problemId?: Id;
  problemTitle?: string;
  problemType?: string;
  submissionTime?: string;
  description?: string;
}

export interface AdminReviewTodoVO {
  pendingPostCount?: number;
  pendingPostCommentCount?: number;
  pendingProblemCommentCount?: number;
  totalPendingCount?: number;
}

export function getReviewTodoCount() {
  return requestData<AdminReviewTodoVO>({
    url: "/admin/review/todo-count",
    method: "GET",
  });
}

export function getProblemTypeDistribution() {
  return requestData<AdminStatItemVO[]>({
    url: "/admin/problem/type-distribution",
    method: "GET",
  });
}

export function getProblemDifficultyDistribution() {
  return requestData<AdminStatItemVO[]>({
    url: "/admin/problem/difficulty-distribution",
    method: "GET",
  });
}

export function getSubmissionTrend(days = 7) {
  return requestData<AdminSubmissionTrendVO[]>({
    url: "/admin/submission/trend",
    method: "GET",
    params: { days },
  });
}

export function getSubmissionLanguageUsage() {
  return requestData<AdminStatItemVO[]>({
    url: "/admin/submission/language",
    method: "GET",
  });
}

export function getRecentActivity(pageSize = 20) {
  return requestData<AdminRecentActivityVO[]>({
    url: "/admin/activity/recent",
    method: "GET",
    params: { pageSize },
  });
}
